import queryString from "query-string";
import { IMAGE_TYPE } from "@dpdgroupuk/redback-enums";
import DefaultPickupShopImage from "../images/PickupShops/Pickup.png";
import { shopLogos } from "../constants/shops";
import { VEHICLE_IMAGE_MAP } from "../constants/drivers";
import Van from "../images/truck.png";
export const getShopImage = value => {
  const shopName = value.toLocaleLowerCase();
  if (shopName.includes("cyclerepublic")) return shopLogos.CycleRepublic;
  if (shopName.includes("doddle")) return shopLogos.Doddle;
  if (shopName.includes("halfords")) return shopLogos.Halfords;
  if (shopName.includes("matalan")) return shopLogos.Matalan;
  if (shopName.includes("sainsburys")) return shopLogos.Sainsburys;
  return DefaultPickupShopImage;
};
export const getImageSize = (width = 80, height = 80) => `${width}*${height}`;
export const getImageUrl = (apiHost, entityPrefix, entityCode, imageId, options = {}) => `${apiHost}/${entityPrefix}/${entityCode}/images/${imageId}?${queryString.stringify(options, {
  skipNull: true,
  encode: false
})}`;
export const getDriverImageUrl = (apiHost, entityPrefix, entityCode, driverPhoto, options = {}) => getImageUrl(apiHost, entityPrefix, entityCode, driverPhoto, { ...options,
  imageType: IMAGE_TYPE.DRIVER
});
export const getMapImage = ({
  apiHost,
  query,
  code,
  width,
  height,
  themeEvent
}) => height ? `${apiHost}/map/route?${query}=${code}&size=${width}*${height}&themeEvent=${themeEvent}` : null;
export const getVehicleImage = vehicleCode => VEHICLE_IMAGE_MAP[vehicleCode] || Van;